import React from "react";
import { Link, navigate } from "@reach/router";
import Cookies from "js-cookie";
import axios from "axios";

export const pageFilter = (_artist, _prefix) => {
  let menu;
  let artist;
  let menus = ["news", "video", "photo", "profile", "podcast", "funseleb"];
  let prefix = _prefix;

  //console.log("Filter", _artist, _prefix);

  const news = (prefix) => {
    return (
      <li>
        <Link to={prefix + "news"}>NEWS</Link>
      </li>
    );
  };
  const video = (prefix) => {
    return (
      <li>
        <Link to={prefix + "video"}>VIDEO</Link>
      </li>
    );
  };
  const photo = (prefix) => {
    return (
      <li>
        <Link to={prefix + "photo"}>PHOTO</Link>
      </li>
    );
  };
  const profile = (prefix) => {
    return (
      <li>
        <Link to={prefix + "profile"}>PROFILE</Link>
      </li>
    );
  };
  const event = (prefix, url) => {
    return (
      <li>
        <Link to={prefix + url}>EVENT</Link>
      </li>
    );
  };
  const podcast = (prefix) => {
    return (
      <li>
        <Link to={prefix + "podcast"}>PODCAST</Link>
      </li>
    );
  };
  const lelang = (prefix) => {
    return (
      <li>
        <Link to={prefix + "lelang"}>LELANG</Link>
      </li>
    );
  };
  const funseleb = () => {
    return (
      <li>
        <a href="https://funseleb.com">FUNSELEB</a>
      </li>
    );
  };

  //HIDE OR SHOW MENU
  const buildMenu = () => {
    menu = (
      <ul>
        {menus.includes("news") && news(prefix)}
        {menus.includes("video") && video(prefix)}
        {menus.includes("photo") && photo(prefix)}
        {menus.includes("profile") && profile(prefix)}
        {Global.event ? event(prefix, Global.event) : ""}
        { Global.idArtist !== 17 && Global.idArtist !== 21 &&
          Global.idArtist !== 22 &&
          Global.idArtist !== 24 &&
          Global.idArtist !== 26 &&
          Global.idArtist !== 27 &&
          Global.idArtist !== 29 &&
          Global.idArtist !== 30 &&
          Global.idArtist !== 31 &&
          menus.includes("podcast") &&
          podcast(prefix)}
        { Global.idArtist !== 17 && Global.idArtist !== 29 && Global.idArtist !== 30 && Global.idArtist !== 31 && menus.includes("funseleb") && funseleb()}
      </ul>
    );
    return menu;
  };

  switch (_artist) {
    case "wali":
      artist = require("./wali.json");
      buildMenu();
      break;

    case "wilona":
      artist = require("./wilona.json");
      buildMenu();
      break;
    case "erick":
      artist = require("./erick.json");
      menus.splice(5);
      buildMenu();
      break;
    case "erick-tsel":
      artist = require("./erick-tsel.json");
      buildMenu();
      break;
    case "inul":
      artist = require("./inul.json");
      buildMenu();
      break;
    case "judika":
      artist = require("./judika.json");
      buildMenu();
      break;
    case "justin":
      artist = require("./justin.json");
      buildMenu();
      break;
    case "marsha":
      artist = require("./marsha.json");
      buildMenu();
      break;
    case "putdel":
      artist = require("./putdel.json");
      buildMenu();
      break;
    case "rizky":
      artist = require("./rizky.json");
      buildMenu();
      break;
    case "tulus":
      artist = require("./tulus.json");
      buildMenu();
      break;
    case "vebby":
      artist = require("./vebby.json");
      buildMenu();
      break;
    case "elina-joerg":
      artist = require("./elina_joerg.json");
      buildMenu();
      break;
    case "sample": //tissa
      artist = require("./sample.json");
      buildMenu();
      break;
    case "tissa": //tissa
      artist = require("./tissa.json");
      buildMenu();
      break;
    case "nita-vior":
      artist = require("./nita_vior.json");
      buildMenu();
      break;
    case "angela-gilsha":
      artist = require("./angela_gilsha.json");
      buildMenu();
      break;
    case "kayes":
      artist = require("./kayes.json");
      buildMenu();
      break;
    case "punipun":
      artist = require("./punipun.json");
      buildMenu();
      break;
    case "puni":
      artist = require("./puniold.json");
      buildMenu();
      break;
    case "adinda-thomas":
      artist = require("./adinda_thomas.json");
      buildMenu();
      break;
    case "alifa-lubis":
      artist = require("./alifa.json");
      buildMenu();
      break;
    case "nabila-zavira":
      artist = require("./nabila_zavira.json");
      buildMenu();
      break;
    case "edelyn":
      artist = require("./edelyn.json");
      buildMenu();
      break;
    case "rizwan":
      artist = require("./rizwan.json");
      buildMenu();
      break;
    case "elina-wetv3":
      artist = require("./elina_joerg_3days.json");
      buildMenu();
      break;
    case "elina-wetv7":
      artist = require("./elina_joerg_7days.json");
      buildMenu();
      break;
    case "melati-sesilia":
      artist = require("./melati-sesilia.json");
      buildMenu();
      break;
  }

  return {
    prefix: prefix,
    menu: menu,
    artist: artist,
    rebuildMenu: buildMenu,
  };
};

export const cssVar = (name, val) => {
  document.documentElement.style.setProperty(name, val);
};

export const Global = {
  access: 0,
  users: {},
  artist: null,
  event: false,
  idArtist: 0,
};

export const checkMenu = (artistId, artist, fn) => {
  Global.idArtist = artistId;
  if (Global.artist != artist) {
    axios
      .get("/w/api/" + artistId + "/menu", {
        headers: {
          PortalAuth: getArtistCookie(artist),
        },
      })
      .then((response) => {
        var menu = response.data;
        Global.event = menu.event;
        Global.artist = artist;
        fn();
      });
  }
};

export const gotoJoinPage = () => {
  navigate("join");
};

export const hasAnoAccess = (artist) => {
  if (Global.access == 0) {
    // read
    Global.access = parseInt(Cookies.get("ano_" + artist));
    if (!Global.access) Global.access = 0;
  }
  console.log("Access", Global.access);

  if (Global.access >= 5) return false;
  else {
    Global.access = Global.access + 1;
    Cookies.set("ano_" + artist, Global.access, { expires: 30, path: "/" });
    console.log("Access");
    return true;
  }
};

export const setArtistCookie = (artist, data) => {
  Global.users[artist] = data;
  Cookies.set("ap_" + artist, data, { expires: 30, path: "/" });
};

export const getArtistCookie = (artist) => {
  var all = Cookies.get("ap_all");
  var cookie = Cookies.get("ap_" + artist);
  if (!cookie) {
    cookie = all;
    if (!cookie) cookie = "";
  } else {
    if (all) cookie = cookie + ":" + all;
  }
  return cookie;
};
